import { render, staticRenderFns } from "./sidebar-navigation-item-component.vue?vue&type=template&id=12c20860&scoped=true&"
import script from "./sidebar-navigation-item-component.vue?vue&type=script&lang=ts&"
export * from "./sidebar-navigation-item-component.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-navigation-item-component.vue?vue&type=style&index=0&id=12c20860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c20860",
  null
  
)

export default component.exports